(()=>{
 function init(root){
  if(root.dataset.lookReady)return;root.dataset.lookReady='true';
  let active=null,opener=null;
  root.querySelectorAll('[data-look-scene]').forEach(scene=>{
   const photo=scene.querySelector('.astra-look-scene'),panels=scene.querySelector('.astra-look-panels');
   photo.append(panels);
  });
  function close(restore=true){
   root.querySelectorAll('[data-look-card]').forEach(card=>card.hidden=true);
   root.querySelectorAll('[data-look-open]').forEach(button=>{button.setAttribute('aria-expanded','false');const icon=button.querySelector('span');if(icon)icon.textContent='+';});
   active=null;if(restore&&opener)opener.focus({preventScroll:true});
  }
  function show(id,trigger){
   if(active===id){close();return;}
   close(false);const card=root.querySelector('[data-look-card="'+id+'"]');if(!card)return;
   active=id;opener=trigger;card.hidden=false;
   root.querySelectorAll('[data-look-open]').forEach(button=>{const on=button.dataset.lookOpen===id;button.setAttribute('aria-expanded',String(on));const icon=button.querySelector('span');if(icon)icon.textContent=on?'−':'+';});
   card.focus({preventScroll:true});
  }
  root.addEventListener('click',event=>{const button=event.target.closest('[data-look-open]');if(button){show(button.dataset.lookOpen,button);return;}if(event.target.closest('[data-look-close]'))close();});
  document.addEventListener('click',event=>{if(active&&!event.target.closest('[data-look-card]')&&!event.target.closest('[data-look-open]'))close(false);});
  root.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){event.preventDefault();close();}});
  root.addEventListener('shopify:block:select',event=>{const button=root.querySelector('[data-look-open="'+event.detail.blockId+'"]');if(button)show(button.dataset.lookOpen,button);});
 }
 document.querySelectorAll('[data-astra-look]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-astra-look]').forEach(init));
})();
